<script>
import DataTableChipColumnVue from 'Support/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import ReportListStatus from 'Support/enums/ReportListStatus';

export default {
  name: 'ReportListStatus',
  extends: DataTableChipColumnVue,
  data() {
    return {
      options: ReportListStatus,
    };
  },
};
</script>
